import React, { useContext } from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { SegmentApi } from "go-segment/services/types";
import { ReportComboContext } from "../services/context";

interface Props {
	segments: SegmentApi[];
}

export const ReportComboSegmentNavigation = (props: Props) => {
	const reportComboContext = useContext(ReportComboContext);
	const segmentCRUDRedirectPath = reportComboContext.getSegmentCRUDRedirectPath();

	return (
		<div className="content-navigation">
			<Nav>
				{props.segments.map((segment) => {
					return (
						<Nav.Item key={segment.id}>
							<Nav.Link exact as={NavLink} to={`${segmentCRUDRedirectPath}/${segment.id}`}>
								{segment.name}
							</Nav.Link>
						</Nav.Item>
					);
				})}
			</Nav>
		</div>
	);
};
